// extracted by mini-css-extract-plugin
module.exports = {"group":"viewGroupsPage_group__2vgNG","tableContainer":"viewGroupsPage_tableContainer__3kl4r","table":"viewGroupsPage_table__bB61T"};